import React from 'react';
import { X, Check, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
interface CompareModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function CompareModal({
  isOpen,
  onClose
}: CompareModalProps) {
  if (!isOpen) return null;
  const plots = [{
    id: 1,
    title: 'Premium Corner Plot',
    location: 'Hinjewadi Phase 1',
    price: '₹45 L',
    size: '2,400 sq.ft',
    rate: '₹1,875/sq.ft',
    zoning: 'Residential',
    road: '12m',
    facing: 'East'
  }, {
    id: 2,
    title: 'Lake View Plot',
    location: 'Whitefield Ext',
    price: '₹65 L',
    size: '1,500 sq.ft',
    rate: '₹4,333/sq.ft',
    zoning: 'Residential',
    road: '9m',
    facing: 'North'
  }, {
    id: 3,
    title: 'Commercial Land',
    location: 'Hyderabad',
    price: '₹5.5 Cr',
    size: '10,000 sq.ft',
    rate: '₹5,500/sq.ft',
    zoning: 'Commercial',
    road: '24m',
    facing: 'West'
  }];
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" data-id="element-484">
      <div className="bg-white w-full max-w-5xl border border-gray-300 shadow-xl relative animate-in fade-in zoom-in-95 duration-200 max-h-[90vh] overflow-y-auto" data-id="element-485">
        <div className="flex justify-between items-center p-6 border-b border-gray-200 sticky top-0 bg-white z-10" data-id="element-486">
          <h2 className="text-xl font-bold" data-id="element-487">Compare Plots</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-488">
            <X className="w-5 h-5" data-id="element-489" />
          </button>
        </div>

        <div className="p-6" data-id="element-490">
          <div className="grid grid-cols-4 gap-4" data-id="element-491">
            {/* Labels Column */}
            <div className="space-y-4 pt-40" data-id="element-492">
              <div className="h-10 flex items-center font-bold text-gray-500 text-sm" data-id="element-493">
                Price
              </div>
              <div className="h-10 flex items-center font-bold text-gray-500 text-sm" data-id="element-494">
                Plot Size
              </div>
              <div className="h-10 flex items-center font-bold text-gray-500 text-sm" data-id="element-495">
                Rate / Sq.ft
              </div>
              <div className="h-10 flex items-center font-bold text-gray-500 text-sm" data-id="element-496">
                Zoning
              </div>
              <div className="h-10 flex items-center font-bold text-gray-500 text-sm" data-id="element-497">
                Road Width
              </div>
              <div className="h-10 flex items-center font-bold text-gray-500 text-sm" data-id="element-498">
                Facing
              </div>
              <div className="h-10 flex items-center font-bold text-gray-500 text-sm" data-id="element-499">
                Legal Status
              </div>
            </div>

            {/* Plot Columns */}
            {plots.map((plot, i) => <div key={i} className="space-y-4 border-l border-gray-200 pl-4" data-id="element-500">
                <div className="h-32 mb-4" data-id="element-501">
                  <div className="w-full h-20 bg-gray-100 border border-dashed border-gray-300 mb-2" data-id="element-502"></div>
                  <h3 className="font-bold text-sm line-clamp-2" data-id="element-503">
                    {plot.title}
                  </h3>
                  <p className="text-xs text-gray-500" data-id="element-504">{plot.location}</p>
                </div>

                <div className="h-10 flex items-center font-bold text-lg" data-id="element-505">
                  {plot.price}
                </div>
                <div className="h-10 flex items-center text-sm" data-id="element-506">
                  {plot.size}
                </div>
                <div className="h-10 flex items-center text-sm font-mono" data-id="element-507">
                  {plot.rate}
                </div>
                <div className="h-10 flex items-center text-sm" data-id="element-508">
                  {plot.zoning}
                </div>
                <div className="h-10 flex items-center text-sm" data-id="element-509">
                  {plot.road}
                </div>
                <div className="h-10 flex items-center text-sm" data-id="element-510">
                  {plot.facing}
                </div>
                <div className="h-10 flex items-center text-green-600 text-xs font-bold uppercase" data-id="element-511">
                  <Check className="w-3 h-3 mr-1" data-id="element-512" /> Verified
                </div>

                <Link to={`/listing/${plot.id}`} onClick={onClose} className="block w-full py-2 bg-[#1f2933] text-white text-xs font-bold hover:bg-gray-800 mt-4 text-center" data-id="element-513">
                  View Details
                </Link>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}